export const language_sv = {
}

export const var_language_sv = {
}

export const err_language_sv = {
}
